const pricingCardClass = ".card";
const pricingElementClass = ".card-pricing";
const pricingCheckboxClass = ".ui-switch__input";
const pricingButtonsClass = ".card-selection__button";
const pricingLinkClass = ".card-button a";
const pricingInputClass = ".card-pricing__input";

const pricingActiveClass = "card-pricing--active";
const pricingButtonActiveClass = "card-selection__button--active";


export function pricingSwitchersLogic()  {
  const cardsPricingElements = [].slice.call(document.querySelectorAll(pricingElementClass));
  if (!cardsPricingElements.length) {
    return;
  }
  function updateLinks(firstLaunch) {
    cardsPricingElements.forEach(function (element) {
      const card = element.closest(pricingCardClass);
      const checkbox = element.querySelector(pricingCheckboxClass);
      const switchButtons = [].slice.call(element.querySelectorAll(pricingButtonsClass));
      if (!card || !checkbox || !switchButtons.length) {
        return
      }
      const link = card.querySelector(pricingLinkClass);
      if (!link) {
        return;
      }
      const inputEl = element.querySelector(pricingInputClass);
      if (inputEl && !inputEl.value && firstLaunch) {
        inputEl.value = switchButtons[0].dataset.text;
      }
      const hrefUrl = new URL(link.href);
      let trial = "notrial";
      if (checkbox.checked) {
        if (!element.classList.contains(pricingActiveClass)) {
          element.classList.add(pricingActiveClass);
        }
        if (inputEl) {
          trial = inputEl.value;
          switchButtons.forEach(function (buttonElement) {
            if (inputEl.value === buttonElement.dataset.text) {
              if (!buttonElement.classList.contains(pricingButtonActiveClass)) {
                buttonElement.classList.add(pricingButtonActiveClass);
              }
            } else {
              if (buttonElement.classList.contains(pricingButtonActiveClass)) {
                buttonElement.classList.remove(pricingButtonActiveClass);
              }
            }
          });
        }
      } else {
        if (element.classList.contains(pricingActiveClass)) {
          element.classList.remove(pricingActiveClass);
        }
      }
      hrefUrl.searchParams.set('trial', trial);
      link.href = hrefUrl.href;
      // console.log("link", hrefUrl.href);
    })
  }
  cardsPricingElements.forEach(function (element) {
    const checkbox = element.querySelector(pricingCheckboxClass);
    const switchButtons = [].slice.call(element.querySelectorAll(pricingButtonsClass));
    if (!checkbox || !switchButtons.length) {
      return
    }
    checkbox.addEventListener('change', () => {
      updateLinks();
    });
    switchButtons.forEach(function (switchButton) {
      switchButton.onclick = function (event) {
        if (!switchButton.closest("." + pricingActiveClass)) {
          return
        }
        const inputEl = element.querySelector(pricingInputClass);
        if (inputEl) {
          inputEl.value = event.target.dataset.text;
        }
        updateLinks();
      }
    });
  });

  setTimeout(() => {
    updateLinks(true); // launch first time
  }, 100)
}
